import { render, staticRenderFns } from "./GFrunwizard.vue?vue&type=template&id=b51922ec"
import script from "./GFrunwizard.vue?vue&type=script&lang=js"
export * from "./GFrunwizard.vue?vue&type=script&lang=js"
import style0 from "./GFrunwizard.vue?vue&type=style&index=0&id=b51922ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports